import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneEnabledIcon from "@mui/icons-material/PhoneEnabled";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import { AppColors } from "../../../../util/AppColors";
import CustomButton from "../../../../components/CustomButton";

const PharmacyDetailsPetPanel = ({ record }) => {
  if (!record) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        padding: "24px",
        borderRadius: "12px",
        border: "1px solid #e0e0e0",
        backgroundColor: "#fff",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 3,
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)"
      }}
    >
      {/* Title */}
      <Typography
        variant="caption"
        sx={{
          fontWeight: 700,
          color: AppColors.gray3,
          letterSpacing: "1.5px",
          fontFamily: "Montserrat",
          textTransform: "uppercase"
        }}
      >
        PET
      </Typography>

      {/* Avatar Placeholder and Name Block */}
      <Box display="flex" flexDirection="column" alignItems="flex-start" sx={{ textAlign: "left", gap: 1.5 }}>
        <Box
          sx={{
            width: "90px",
            height: "90px",
            backgroundColor: "#e0e0e0",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "40px"
          }}
        >
          🐶
        </Box>
        <Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "#1c2434",
              fontFamily: "Montserrat"
            }}
          >
            {record.patientName} ({record.gender === "male" ? "Male" : "Female"})
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: AppColors.gray3,
              fontFamily: "Montserrat",
              mt: 0.5
            }}
          >
            {record.breed} · {record.age} · {record.weight}
          </Typography>
        </Box>
      </Box>

      {/* Owner Information Card with Dashed Border */}
      <Box
        sx={{
          border: "1px dashed #cccccc",
          borderRadius: "8px",
          padding: "16px",
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
          backgroundColor: "#fafafa"
        }}
      >
        {/* Owner Name Row */}
        <Box display="flex" alignItems="center" gap={1.5}>
          <PersonOutlineIcon sx={{ color: AppColors.appPrimary, width: 20, height: 20 }} />
          <Typography variant="body2" sx={{ fontWeight: 600, color: "#1c2434", fontFamily: "Montserrat" }}>
            {record.ownerName}
          </Typography>
        </Box>

        {/* Owner Email Row */}
        <Box display="flex" alignItems="center" gap={1.5}>
          <MailOutlineIcon sx={{ color: AppColors.appPrimary, width: 20, height: 20 }} />
          <Typography
            variant="body2"
            sx={{
              color: AppColors.gray3,
              fontFamily: "Montserrat",
              wordBreak: "break-all"
            }}
          >
            {record.ownerEmail ?? `${record.ownerName.toLowerCase()}@yopmail.com`}
          </Typography>
        </Box>

        {/* Owner Phone Row */}
        <Box display="flex" alignItems="center" gap={1.5}>
          <PhoneEnabledIcon sx={{ color: AppColors.appPrimary, width: 20, height: 20 }} />
          <Typography variant="body2" sx={{ color: AppColors.gray3, fontFamily: "Montserrat" }}>
            {record.ownerPhone ?? "9787563739"}
          </Typography>
        </Box>
      </Box>

      {/* Chat Action Button */}
      <Box>
        <button
          onClick={() => alert(`Start chat with owner ${record.ownerName}`)}
          style={{
            backgroundColor: "#f1f3f4",
            color: "#1c2434",
            border: "none",
            borderRadius: "6px",
            height: "36px",
            width: "100%",
            fontSize: "14px",
            fontWeight: "700",
            fontFamily: "Montserrat",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px"
          }}
        >
          <QuestionAnswerIcon sx={{ width: 16, height: 16 }} />
          Chat
        </button>
      </Box>
    </Paper>
  );
};

export default PharmacyDetailsPetPanel;
